/**
 * Date-extensions locale Frisian [fy]
 */
import DateExtended from "../date-extended";
DateExtended.addLocale('fy', {
    monthNames: ['Jannewaris','Febrewaris','Maart','April','Maaie','Juny','July','Augustus','Septimber','Oktober','Novimber','Desimber'],
    monthShortNames: ['Jan.','Feb.','Mrt.','Apr.','Mai','Jun.','Jul.','Aug.','Sep.','Okt.','Nov.','Des.'],
    dayNames: ['Snein','Moandei','Tiisdei','Woansdei','Tongersdei','Freed','Sneon'],
    dayShortNames: ['Si.','Mo.','Ti.','Wo.','To.','Fr.','So.']
});
